// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d1a406f3","806":"e9c591f5"}[chunkId] + ".chunk.js";
};